var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139.702,
    height: 72.358,
    viewBox: "0 0 139.702 72.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5336",
    "data-name": "Rectangle 5336",
    width: 139.702,
    height: 72.358,
    fill: "#a1a1b3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812",
    transform: "translate(-0.177 0.499)",
    opacity: 0.156
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27754",
    "data-name": "Path 27754",
    d: "M14.28,66.607,44.328,39.833l1.818-1.62,1.7,1.742,17.588,17.97,38.24-12.432L139.854,8.37l3.664,3.646L106.9,49.595l-1.047.652L65.508,63.363l-1.5.488L62.9,62.722,45.912,45.363,17.682,70.517Z",
    transform: "translate(-7.819 -4.902)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9727",
    "data-name": "Group 9727",
    transform: "translate(0.177 -0.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9726",
    "data-name": "Group 9726",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27755",
    "data-name": "Path 27755",
    d: "M6.355,144.3A6.45,6.45,0,1,0,0,137.82,6.418,6.418,0,0,0,6.355,144.3",
    transform: "translate(-0.089 -71.816)",
    fill: "#a1a1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27756",
    "data-name": "Path 27756",
    d: "M76.105,83.551a6.45,6.45,0,1,0-6.355-6.482,6.418,6.418,0,0,0,6.355,6.482",
    transform: "translate(-38.641 -38.506)",
    fill: "#a1a1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27757",
    "data-name": "Path 27757",
    d: "M118.122,124.91a6.45,6.45,0,1,0-6.355-6.482,6.418,6.418,0,0,0,6.355,6.482",
    transform: "translate(-61.864 -61.183)",
    fill: "#a1a1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27758",
    "data-name": "Path 27758",
    d: "M208.3,95.929a6.45,6.45,0,1,0-6.355-6.482,6.418,6.418,0,0,0,6.355,6.482",
    transform: "translate(-111.708 -45.293)",
    fill: "#a1a1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27759",
    "data-name": "Path 27759",
    d: "M290.155,12.9A6.45,6.45,0,1,0,283.8,6.418a6.418,6.418,0,0,0,6.355,6.482",
    transform: "translate(-156.949 0.232)",
    fill: "#a1a1b3",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/Graphic.19089cb0e9edc0615ee94bc9da76f9ae.svg";
export { ForwardRef as ReactComponent };